// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dcdc0f5f","239":"3db46b31","453":"a8b7aea4","732":"fcc81b99"}[chunkId] + ".chunk.js";
};